import { CALL_API } from 'middlewares/api';
import { url } from 'configs/';
import fetchData from 'utils/api';
const {
  NEWTUBE_API_SERVER,
} = url;
import { clone } from 'lodash';
const FETCH_INITIAL_STATUS_REQUEST = 'companyAdmin/orgImport/FETCH_INITIAL_STATUS_REQUEST';
const FETCH_INITIAL_STATUS_SUCCESS = 'companyAdmin/orgImport/FETCH_INITIAL_STATUS_SUCCESS';
const FETCH_INITIAL_STATUS_FAIL = 'companyAdmin/orgImport/FETCH_INITIAL_STATUS_FAIL';
const SET_STATE_TO_UPLOADING = 'companyAdmin/orgImport/SET_STATE_TO_UPLOADING';
export const STATE_FOUNDATION = 'companyAdmin/orgImport/STATE_FOUNDATION';
export const STATE_CERTIFICATE = 'companyAdmin/orgImport/STATE_CERTIFICATE';
export const STATE_EDUCATION = 'companyAdmin/orgImport/STATE_EDUCATION';
export const STATE_WORKING = 'companyAdmin/orgImport/STATE_WORKING';

export default function reducer(state = {
  isLoading: false,
  isLoaded: false,
  initialState: {
    foundationState: {
      status: undefined,
      message: '',
      updated_at: undefined,
    },
    certificateState: {
      status: undefined,
      message: '',
      updated_at: undefined,
    },
    educationState: {
      status: undefined,
      message: '',
      updated_at: undefined,
    },
    workingState: {
      status: undefined,
      message: '',
      updated_at: undefined,
    },
  },
}, action) {
  switch (action.type) {
    case FETCH_INITIAL_STATUS_REQUEST:
      return Object.assign({}, state, {
        isLoading: true,
      });
    case FETCH_INITIAL_STATUS_SUCCESS:
      {
        const initialState = {
          foundationState: {
            status: undefined,
            message: '',
            updated_at: undefined,
          },
          certificateState: {
            status: undefined,
            message: '',
            updated_at: undefined,
          },
          educationState: {
            status: undefined,
            message: '',
            updated_at: undefined,
          },
          workingState: {
            status: undefined,
            message: '',
            updated_at: undefined,
          },
        };
        action.response.data.forEach((status) => {
          switch (status.importType) {
            case 'Foundation':
              initialState.foundationState.status = status.importStatus;
              initialState.foundationState.message = status.errorMessage;
              initialState.foundationState.updated_at = status.updateAt;
              break;
            case 'PACertificate':
              initialState.certificateState.status = status.importStatus;
              initialState.certificateState.message = status.errorMessage;
              initialState.certificateState.updated_at = status.updateAt;
              break;
            case 'PAEducation':
              initialState.educationState.status = status.importStatus;
              initialState.educationState.message = status.errorMessage;
              initialState.educationState.updated_at = status.updateAt;
              break;
            case 'PAWorking':
              initialState.workingState.status = status.importStatus;
              initialState.workingState.message = status.errorMessage;
              initialState.workingState.updated_at = status.updateAt;
              break;
            default:
              break;
          }
        });
        return Object.assign({}, state, {
          isLoading: false,
          isLoaded: true,
          initialState,
        });
      }
    case FETCH_INITIAL_STATUS_FAIL:
      return Object.assign({}, state, {
        isLoading: false,
        isLoaded: false,
      });
    case SET_STATE_TO_UPLOADING:
      {
        const initialState = state.initialState;
        switch (action.stateType) {
          case STATE_FOUNDATION:
            {
              const newState = clone(initialState.foundationState);
              newState.status = 'FileUploading';
              initialState.foundationState = newState;
              return Object.assign({}, state, { initialState });
            }
          case STATE_EDUCATION:
            {
              const newState = clone(initialState.educationState);
              newState.status = 'FileUploading';
              initialState.educationState = newState;
              return Object.assign({}, state, { initialState });
            }
          case STATE_WORKING:
            {
              const newState = clone(initialState.workingState);
              newState.status = 'FileUploading';
              initialState.workingState = newState;
              return Object.assign({}, state, { initialState });
            }
          case STATE_CERTIFICATE:
            {
              const newState = clone(initialState.certificateState);
              newState.status = 'FileUploading';
              initialState.certificateState = newState;
              return Object.assign({}, state, { initialState });
            }
          default:
            return state;
        }
      }
    default:
      return state;
  }
}
export function fetchInitialState() {
  return {
    [CALL_API]: {
      types: [
        FETCH_INITIAL_STATUS_REQUEST,
        FETCH_INITIAL_STATUS_SUCCESS,
        FETCH_INITIAL_STATUS_FAIL,
      ],
      url: NEWTUBE_API_SERVER + 'FoundationImport/Status',
      method: 'GET',
    },
  };
}

export function loadInitialState() {
  return (dispatch) => {
    dispatch(fetchInitialState());
    setInterval(() => {
      dispatch(fetchInitialState());
    }, 30000);
  };
}

export function uploadFundationData(headers, formData) {
  const fetchOptions = {
    mode: 'cors',
    method: 'POST',
    headers,
  };

  fetchOptions.body = formData;

  const fullUrl = NEWTUBE_API_SERVER + 'FoundationImport/Foundation';

  return fetchData(fullUrl, fetchOptions);
}

export function deleteFundationData(headers) {
  const fetchOptions = {
    mode: 'cors',
    method: 'DELETE',
    headers,
  };

  const fullUrl = NEWTUBE_API_SERVER + 'FoundationImport/Foundation';

  return fetchData(fullUrl, fetchOptions);
}

export function uploadEducationData(headers, formData) {
  const fetchOptions = {
    mode: 'cors',
    method: 'POST',
    headers,
  };

  fetchOptions.body = formData;

  const fullUrl = NEWTUBE_API_SERVER + 'FoundationImport/PAEducation';

  return fetchData(fullUrl, fetchOptions);
}

export function deleteEducationData(headers) {
  const fetchOptions = {
    mode: 'cors',
    method: 'DELETE',
    headers,
  };

  const fullUrl = NEWTUBE_API_SERVER + 'FoundationImport/PAEducation';

  return fetchData(fullUrl, fetchOptions);
}

export function uploadWorkingData(headers, formData) {
  const fetchOptions = {
    mode: 'cors',
    method: 'POST',
    headers,
  };

  fetchOptions.body = formData;

  const fullUrl = NEWTUBE_API_SERVER + 'FoundationImport/PAWorking';

  return fetchData(fullUrl, fetchOptions);
}

export function deleteWorkingData(headers) {
  const fetchOptions = {
    mode: 'cors',
    method: 'DELETE',
    headers,
  };

  const fullUrl = NEWTUBE_API_SERVER + 'FoundationImport/PAWorking';

  return fetchData(fullUrl, fetchOptions);
}

export function uploadCertificateData(headers, formData) {
  const fetchOptions = {
    mode: 'cors',
    method: 'POST',
    headers,
  };

  fetchOptions.body = formData;

  const fullUrl = NEWTUBE_API_SERVER + 'FoundationImport/PACertificate';

  return fetchData(fullUrl, fetchOptions);
}

export function deleteCertificateData(headers) {
  const fetchOptions = {
    mode: 'cors',
    method: 'DELETE',
    headers,
  };

  const fullUrl = NEWTUBE_API_SERVER + 'FoundationImport/PACertificate';

  return fetchData(fullUrl, fetchOptions);
}

export function setStateToUploading(stateType) {
  return {
    type: SET_STATE_TO_UPLOADING,
    stateType,
  };
}

export function finishImport(headers) {
  const fetchOptions = {
    mode: 'cors',
    method: 'POST',
    headers,
  };

  const fullUrl = NEWTUBE_API_SERVER + 'FoundationImport/FinishImport';

  return fetchData(fullUrl, fetchOptions);
}



/** WEBPACK FOOTER **
 ** F:/agent-C107052-04/_work/417/s/Tube.Frontend/src/containers/App/screens/Tube/screens/CompanyAdmin/OrgImport/reducers/index.js
 **/